import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface BlogLayoutProps {
  children: ReactNode
}

export default function BlogLayout({ children }: BlogLayoutProps) {
  return (
    <div className="min-h-screen bg-slate-50 font-sans flex flex-col">
      {/* Nav */}
      <nav className="bg-white border-b border-gray-200 py-4 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold tracking-tight text-[#1B365D]">
            STEADFAST <span className="text-[#C9A227]">HSA</span>
          </Link>
          <div className="flex items-center gap-6 text-sm font-semibold text-slate-600">
            <Link to="/blog" className="hover:text-[#1B365D] transition">
              Blog
            </Link>
            <Link to="/" className="hover:text-[#1B365D] transition">
              ← Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 py-12">
        {children}
      </main>

      {/* Footer */}
      <footer className="py-12 bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <div className="mb-6 md:mb-0">
            <span className="font-bold text-[#1B365D]">STEADFAST HSA</span> &copy; {new Date().getFullYear()}. Built for the long term.
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/" className="hover:text-[#1B365D] transition">Home</Link>
            <Link to="/blog" className="hover:text-[#1B365D] transition font-semibold text-[#1B365D]">Blog</Link>
            <Link to="/privacy" className="hover:text-[#1B365D] transition">Privacy</Link>
            <Link to="/terms" className="hover:text-[#1B365D] transition">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
